var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.24647",
      "ably-hubspot-js": "static-1.435",
      "enviro": "static-4.275",
      "head-dlb": "static-1.2518",
      "hs-lodash": "static-4.9",
      "hs-promise-utils": "static-1.2917",
      "hs-test-utils": "static-1.5495",
      "hub-http": "static-1.2732",
      "hubspot-url-utils": "static-1.1994",
      "HubStyleTokens": "static-2.9055",
      "I18n": "static-7.1303",
      "jasmine-runner": "static-1.3877",
      "nav-meta": "static-1.23440",
      "navigation-components": "static-1.11803",
      "navigation-components-tests": "static-1.8413",
      "quartz": "static-1.4059",
      "react": "static-7.133",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "webpack-env": "static-1.41",
      "wootric-nps": "static-1.4462",
      "ably": "static-1.18",
      "calling-internal-common": "static-1.28440",
      "classnames": "static-2.10",
      "crosstab": "static-1.2066",
      "ExtensionInstallHelpers": "static-1.507",
      "foundations-components": "static-1.4203",
      "foundations-theming": "static-1.1414",
      "foundations-theming-base": "static-1.399",
      "frontend-preferences-client": "static-1.5333",
      "global-search-externals": "static-1.6626",
      "idb-keyval": "static-1.14",
      "magpie-lib": "static-1.2946",
      "magpie-types": "static-1.2405",
      "metrics-js": "static-1.7101",
      "nav-onboarding-tours": "static-1.513",
      "navigation-messaging": "static-1.1130",
      "notification-sounds": "static-1.1915",
      "prefetcher": "static-1.3240",
      "react-dom": "static-7.85",
      "react-utils": "static-2.3181",
      "redux-thunk": "static-2.17",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.5657",
      "simple-logging-lib": "static-1.563",
      "styled-components": "static-2.40",
      "superstore": "static-1.2231",
      "trial-components-library": "static-1.8831",
      "ts-schema": "static-1.1934",
      "ui-images": "static-2.766",
      "usage-tracker-core": "static-1.4901",
      "hs-promise-rejection-tracking": "static-1.2904",
      "PortalIdParser": "static-2.254",
      "raven": "static-3.3217",
      "raven-hubspot": "static-1.3524",
      "bend-plugin-trellis-migration": "static-1.1076",
      "moment": "static-3.26",
      "HeadJS": "static-2.518",
      "quartz-core": "static-1.3278",
      "framer-motion": "static-1.30",
      "hs-test-utils-bend-plugin": "static-1.606",
      "msw": "static-1.39",
      "testing-library": "static-1.113",
      "i18n-data": "static-1.188",
      "moment-timezone": "static-5.17",
      "jasmine": "static-4.1798",
      "quartz-core-utils": "static-1.926",
      "StyleGuideUI": "static-3.433",
      "csstype": "static-1.8",
      "hoist-non-react-statics": "static-3.9",
      "HubStyle": "static-2.9365",
      "calling-error-reporting": "static-1.28445",
      "calling-usage-tracker": "static-1.3999",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "quick-fetch": "static-1.1826",
      "self-service-api": "static-1.7559",
      "SharedI18nStrings": "static-1.160",
      "UIComponents": "static-3.6005",
      "bend-plugin-foundations-components": "static-1.471",
      "floating-ui": "static-1.20",
      "foundations-assets": "static-1.2290",
      "hs-story-utils": "static-1.6498",
      "react-aria": "static-1.32",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.67",
      "tanstack-table": "static-1.10",
      "ui-fonts": "static-1.327",
      "global-search-shared": "static-1.7338",
      "usage-tracker": "static-1.5051",
      "react-rhumb": "static-1.14008",
      "autolinker": "static-3.11",
      "sanitize": "static-1.6",
      "transmute": "static-2.29",
      "atom": "static-1.2877",
      "ai-components-ui-library": "static-1.3509",
      "copilot-toolkit": "static-1.2632",
      "demographics-client": "static-1.2843",
      "icons": "static-2.585",
      "laboratory-lib": "static-3.4601",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.490",
      "signup-constants": "static-1.14001",
      "ui-addon-i18n": "static-1.8246",
      "ui-addon-upgrades": "static-9.14283",
      "user-context": "static-1.2552",
      "dispatcher": "static-1.105",
      "general-store": "static-6.20",
      "history": "static-4.15",
      "hub-http-janus": "static-1.586",
      "hub-http-shared-msw-handlers": "static-1.5381",
      "hubspotter-http": "static-1.2535",
      "hubspotter-http-shared-msw-handlers": "static-1.5379",
      "mobile-manifest-mixins": "static-1.289",
      "platform-navigation-bootstrap": "static-1.9305",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.320",
      "customer-data-ui-utilities": "static-1.7238",
      "ai-addon-copilot-preview": "static-1.2721",
      "apollo-link-hub-http": "static-2.2224",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.6746",
      "graphql": "static-1.51",
      "search-service-types": "static-1.1588",
      "chatspot-client-types": "static-1.6663",
      "chatspot-core": "static-1.11769",
      "ContentUtils": "static-1.59518",
      "sassPrefix": "static-1.121",
      "feature-store-service-types": "static-1.2378",
      "growth-monetization-service-types": "static-1.2385",
      "rpc-client-utils": "static-1.2141",
      "upgrade-management-service-types": "static-1.2369",
      "getting-started-shared-tasks": "static-1.7546",
      "getting-started-shared-tasks-store": "static-1.6664",
      "platform-infra-nav-components": "static-1.5637",
      "react-dnd-compat": "static-1.1926",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.4067",
      "cms-field-types": "static-1.2239",
      "content-icons-ui": "static-1.1816",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.7009",
      "ui-addon-react-router-dom": "static-1.7038",
      "usage-tracker-container": "static-1.5041"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.24647",
      "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
      "enviro": "/enviro/static-4.275",
      "head-dlb": "/head-dlb/static-1.2518",
      "hs-lodash": "/hs-lodash/static-4.9",
      "hs-promise-utils": "/hs-promise-utils/static-1.2917",
      "hs-test-utils": "/hs-test-utils/static-1.5495",
      "hub-http": "/hub-http/static-1.2732",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.1994",
      "HubStyleTokens": "/HubStyleTokens/static-2.9055",
      "I18n": "/I18n/static-7.1303",
      "jasmine-runner": "/jasmine-runner/static-1.3877",
      "nav-meta": "/nav-meta/static-1.23440",
      "navigation-components": "/navigation-components/static-1.11803",
      "navigation-components-tests": "/navigation-components-tests/static-1.8413",
      "quartz": "/quartz/static-1.4059",
      "react": "/react/static-7.133",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "webpack-env": "/webpack-env/static-1.41",
      "wootric-nps": "/wootric-nps/static-1.4462",
      "ably": "/ably/static-1.18",
      "calling-internal-common": "/calling-internal-common/static-1.28440",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.2066",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.507",
      "foundations-components": "/foundations-components/static-1.4203",
      "foundations-theming": "/foundations-theming/static-1.1414",
      "foundations-theming-base": "/foundations-theming-base/static-1.399",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.5333",
      "global-search-externals": "/global-search-externals/static-1.6626",
      "idb-keyval": "/idb-keyval/static-1.14",
      "magpie-lib": "/magpie-lib/static-1.2946",
      "magpie-types": "/magpie-types/static-1.2405",
      "metrics-js": "/metrics-js/static-1.7101",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.513",
      "navigation-messaging": "/navigation-messaging/static-1.1130",
      "notification-sounds": "/notification-sounds/static-1.1915",
      "prefetcher": "/prefetcher/static-1.3240",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.3181",
      "redux-thunk": "/redux-thunk/static-2.17",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.5657",
      "simple-logging-lib": "/simple-logging-lib/static-1.563",
      "styled-components": "/styled-components/static-2.40",
      "superstore": "/superstore/static-1.2231",
      "trial-components-library": "/trial-components-library/static-1.8831",
      "ts-schema": "/ts-schema/static-1.1934",
      "ui-images": "/ui-images/static-2.766",
      "usage-tracker-core": "/usage-tracker-core/static-1.4901",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.2904",
      "PortalIdParser": "/PortalIdParser/static-2.254",
      "raven": "/raven/static-3.3217",
      "raven-hubspot": "/raven-hubspot/static-1.3524",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1076",
      "moment": "/moment/static-3.26",
      "HeadJS": "/HeadJS/static-2.518",
      "quartz-core": "/quartz-core/static-1.3278",
      "framer-motion": "/framer-motion/static-1.30",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.606",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.113",
      "i18n-data": "/i18n-data/static-1.188",
      "moment-timezone": "/moment-timezone/static-5.17",
      "jasmine": "/jasmine/static-4.1798",
      "quartz-core-utils": "/quartz-core-utils/static-1.926",
      "StyleGuideUI": "/StyleGuideUI/static-3.433",
      "csstype": "/csstype/static-1.8",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "HubStyle": "/HubStyle/static-2.9365",
      "calling-error-reporting": "/calling-error-reporting/static-1.28445",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.3999",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "quick-fetch": "/quick-fetch/static-1.1826",
      "self-service-api": "/self-service-api/static-1.7559",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "UIComponents": "/UIComponents/static-3.6005",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.471",
      "floating-ui": "/floating-ui/static-1.20",
      "foundations-assets": "/foundations-assets/static-1.2290",
      "hs-story-utils": "/hs-story-utils/static-1.6498",
      "react-aria": "/react-aria/static-1.32",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.67",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-fonts": "/ui-fonts/static-1.327",
      "global-search-shared": "/global-search-shared/static-1.7338",
      "usage-tracker": "/usage-tracker/static-1.5051",
      "react-rhumb": "/react-rhumb/static-1.14008",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.6",
      "transmute": "/transmute/static-2.29",
      "atom": "/atom/static-1.2877",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.3509",
      "copilot-toolkit": "/copilot-toolkit/static-1.2632",
      "demographics-client": "/demographics-client/static-1.2843",
      "icons": "/icons/static-2.585",
      "laboratory-lib": "/laboratory-lib/static-3.4601",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.490",
      "signup-constants": "/signup-constants/static-1.14001",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.8246",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.14283",
      "user-context": "/user-context/static-1.2552",
      "dispatcher": "/dispatcher/static-1.105",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.15",
      "hub-http-janus": "/hub-http-janus/static-1.586",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.5381",
      "hubspotter-http": "/hubspotter-http/static-1.2535",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.5379",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.289",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.9305",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.320",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7238",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.2721",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2224",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.6746",
      "graphql": "/graphql/static-1.51",
      "search-service-types": "/search-service-types/static-1.1588",
      "chatspot-client-types": "/chatspot-client-types/static-1.6663",
      "chatspot-core": "/chatspot-core/static-1.11769",
      "ContentUtils": "/ContentUtils/static-1.59518",
      "sassPrefix": "/sassPrefix/static-1.121",
      "feature-store-service-types": "/feature-store-service-types/static-1.2378",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2385",
      "rpc-client-utils": "/rpc-client-utils/static-1.2141",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2369",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.7546",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.6664",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.5637",
      "react-dnd-compat": "/react-dnd-compat/static-1.1926",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.4067",
      "cms-field-types": "/cms-field-types/static-1.2239",
      "content-icons-ui": "/content-icons-ui/static-1.1816",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7009",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7038",
      "usage-tracker-container": "/usage-tracker-container/static-1.5041"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};